module.exports = __webpack_public_path__ + "assets/img/translation-app-4.a59ec176.png";